/**************************************************
 * Nombre:       Tarjeta_Beneficios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {theme} from "../../Tema";
import iso from "../../Recursos/iso_azul.svg";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Wass from "../Dialogos/Dialogo_Wass";


const Tarjeta_Beneficios = ({item}) => {
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Wass, titulo: 'Iniciar Conversación'})

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: 'white',
                p: 3,
                color: '#000',
                boxShadow: 4
            }}
        >

            <Dialogo/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{
                        fontFamily: NEGRITA,
                        fontSize: 32,
                        fontWeight: 600,
                        color: theme.palette.primary.main,
                        lineHeight: 1.1
                    }}>
                    {item.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography
                    sx={{fontSize: 16, fontWeight: 400}}>
                    {item.descripcion}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 3}}>
                <Button
                    onClick={() => abrir({asunto: item.nombre})}
                    color={'secondary'}
                    startIcon={<img src={iso} style={{width: 24, height: 24, marginRight: 10}}/>}>
                    Mas Informacion
                </Button>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Beneficios